<div class="bg-e-white">
  <div class="md:py-[50px] rounded-xl">
    <div class="container-default flex flex-col-reverse md:flex-row md:justify-between px-6">
      <div class="flex flex-col items-start justify-center md:w-1/3 md:me-6">
        <h1 class="" itemprop="name">{{_boxpage?.title}}</h1>

        @if (!isOnServer) {
          <div class="my-5" [innerHTML]="_boxpage?.shortdescription | safeHtml"></div>
        }

        <div class="flex w-full justify-between mt-6">
          <span class="my-auto me-2">{{'common.person' | translate}}</span>
          <app-personselection class="w-2/3" [colorscheme]="'white'" [doublepersons]="box?.doublepersons"  [personsoptions]="box?._boxpersons" [persons]="personsCtrl.value" (personsChange)="personsCtrl.setValue($event)"></app-personselection>
        </div>
        <div class="flex w-full justify-between mt-6">
          
          <span class="my-auto me-2">{{'boxpage.quantity_boxes' | translate}}</span>
          <app-quantityselection class="w-2/3" [colorscheme]="'white'" [min]="1" [quantity]="quantity.value" (quantityChange)="quantity.setValue($event)" ></app-quantityselection>
        </div>
        @if (singleboxsellable()) {
          <button (click)="chooseBox()" class="button-base rounded-full mt-6" id="choosebox">
            <span>{{'singleorder.add_to_cart' | translate }}</span>
          </button>
        } @else if(box) {

        <div class="bg-e-gold rounded text-center text-white px-2 py-3 mt-6 w-full">
          {{'boxpage.box_sellable_in_period' | translate }}
          <span class="d-block">
            @if (box?.singleboxsellablefrom) { {{'common.from' | translate | lowercase }} <strong>{{box.singleboxsellablefrom | date: 'dd MMMM yyyy'}}</strong> }
            @if (box?.singleboxsellableto){ {{'common.to' | translate | lowercase}} <strong>{{box.singleboxsellableto | date: 'dd MMMM yyyy'}}</strong> }
          </span>
        </div>
        }
      </div>

  <div class="md:w-2/3">
    <app-image size="lg" [imageobject]="imageRecipes[0]" class="rounded-3xl object-cover w-full"></app-image>
  </div>
</div>
</div>
<div class="container-default flex flex-col px-6">

  @if (!isOnServer) {
    <div class="my-5" [innerHTML]="_boxpage?.description | safeHtml"></div>
  }

  <h2 class="mt-6">{{'box.content' | translate}}</h2>
  @if (loading) {
    <app-loader></app-loader>
  }
   @if (box?.boxPeriods && box?.boxPeriods.length>0) {
        <div class="flex flex-col md:flex-row gap-6 mb-6">
          <recipe-list [recipes]="recipes" [loading]="recipesloading" [allergens]="allergensCtrl.value" class="w-full" [ngClass]="{'md:w-3/5': box?.boxPeriods[0].boxProducts.length >0}">
            <ng-template #recipe let-recipe>
              <recipecard [recipe]="recipe" [status]="'PROCESSED'" [selectedallergens]="allergensCtrl.value" (showRecipe)="showRecipe($event)"> </recipecard>
            </ng-template>
          </recipe-list>
          @if (box?.boxPeriods[0].boxProducts.length >0) {
          <div class="w-full md:w-2/5">
            <div class="bg-white rounded-xl p-6">
              <h2>{{'box.extraproducts' | translate}}</h2>
              <app-ingredientlist [doublepersons]="box?.doublepersons" [personquantity]="personsCtrl.value" [personsoptions]="box?._boxpersons" [ingredients]="box?.boxPeriods[0].boxProducts"></app-ingredientlist>
            </div>
          </div>
          }
    </div>
    }@else {
    <span>{{'box.content_not_filled_yet' |translate}}</span>
    }

  @if (_boxpage?.boxpagefaqs) {
    <div class="mt-6">
      @for (faq of _boxpage?.boxpagefaqs; track faq) {
        <faq [faqid]="faq.faqid" colorscheme="contrast"></faq>
      }
    </div>
  }
</div>
</div>

<ng-template #recipeTmpl>

  <div class="flex flex-col w-fit overflow-auto bg-white p-3">
    <div class="flex justify-end">
      <button (click)="offcanvasService.dismiss();"><i class="bi bi-x-lg"></i></button>
    </div>
    <div class="flex justify-center h-full">
      <app-recipe class="mb-5" [personquantity]="personsCtrl.value" [recipe]="shownRecipe"></app-recipe>
    </div>
  </div>

</ng-template>